import { IEventForm } from 'components/organisms/forms/event/EventForm';
import { IEventResponse } from 'services/events/types';

export const eventQueryToForm = (eventQuery: IEventResponse): IEventForm => {
  const convertToDateString = (isoString: string): string => {
    if (!isoString) return '';
    return new Date(isoString).toISOString().split('T')[0];
  };

  return {
    version: eventQuery.version,
    id: eventQuery.id,
    name: eventQuery.name,
    status: eventQuery.status,
    startDate: convertToDateString(eventQuery.startDate),
    endDate: convertToDateString(eventQuery.endDate),
    labels: eventQuery.labels,
  };
};
